/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as AppRouteImport } from './../../pages/_app'
import { Route as AppIndexRouteImport } from './../../pages/_app.index'
import { Route as AppCalendarRouteImport } from './../../pages/_app.calendar'
import { Route as AppInboxRouteImport } from './../../pages/_app.inbox'
import { Route as AppSearchRouteImport } from './../../pages/_app.search'
import { Route as AppSettingsRouteImport } from './../../pages/_app.settings'
import { Route as AppStitRouteImport } from './../../pages/_app.stit'
import { Route as AppTeamRouteImport } from './../../pages/_app.team'
import { Route as BookingTokenRouteImport } from './../../pages/booking.$token'
import { Route as AppCompaniesIndexRouteImport } from './../../pages/_app.companies.index'
import { Route as AppCompaniesCompanyIdRouteImport } from './../../pages/_app.companies.$companyId'
import { Route as AppEmployeesEmployeeIdRouteImport } from './../../pages/_app.employees.$employeeId'
import { Route as AppEventsEventIdRouteImport } from './../../pages/_app.events.$eventId'
import { Route as AppProjectsProjectIdRouteImport } from './../../pages/_app.projects.$projectId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppStitRoute = AppStitRouteImport.update({
  id: '/stit',
  path: '/stit',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const BookingTokenRoute = BookingTokenRouteImport.update({
  id: '/booking/$token',
  path: '/booking/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCompaniesIndexRoute = AppCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesCompanyIdRoute = AppCompaniesCompanyIdRouteImport.update({
  id: '/companies/$companyId',
  path: '/companies/$companyId',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployeesEmployeeIdRoute = AppEmployeesEmployeeIdRouteImport.update({
  id: '/employees/$employeeId',
  path: '/employees/$employeeId',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsEventIdRoute = AppEventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/calendar': typeof AppCalendarRoute
  '/inbox': typeof AppInboxRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRoute
  '/stit': typeof AppStitRoute
  '/team': typeof AppTeamRoute
  '/booking/$token': typeof BookingTokenRoute
  '/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/events/$eventId': typeof AppEventsEventIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/companies/': typeof AppCompaniesIndexRoute
}
export interface FileRoutesByTo {
  '/calendar': typeof AppCalendarRoute
  '/inbox': typeof AppInboxRoute
  '/search': typeof AppSearchRoute
  '/settings': typeof AppSettingsRoute
  '/stit': typeof AppStitRoute
  '/team': typeof AppTeamRoute
  '/booking/$token': typeof BookingTokenRoute
  '/': typeof AppIndexRoute
  '/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/events/$eventId': typeof AppEventsEventIdRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/companies': typeof AppCompaniesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/stit': typeof AppStitRoute
  '/_app/team': typeof AppTeamRoute
  '/booking/$token': typeof BookingTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/companies/$companyId': typeof AppCompaniesCompanyIdRoute
  '/_app/employees/$employeeId': typeof AppEmployeesEmployeeIdRoute
  '/_app/events/$eventId': typeof AppEventsEventIdRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRoute
  '/_app/companies/': typeof AppCompaniesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calendar'
    | '/inbox'
    | '/search'
    | '/settings'
    | '/stit'
    | '/team'
    | '/booking/$token'
    | '/companies/$companyId'
    | '/employees/$employeeId'
    | '/events/$eventId'
    | '/projects/$projectId'
    | '/companies/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/calendar'
    | '/inbox'
    | '/search'
    | '/settings'
    | '/stit'
    | '/team'
    | '/booking/$token'
    | '/'
    | '/companies/$companyId'
    | '/employees/$employeeId'
    | '/events/$eventId'
    | '/projects/$projectId'
    | '/companies'
  id:
    | '__root__'
    | '/_app'
    | '/_app/calendar'
    | '/_app/inbox'
    | '/_app/search'
    | '/_app/settings'
    | '/_app/stit'
    | '/_app/team'
    | '/booking/$token'
    | '/_app/'
    | '/_app/companies/$companyId'
    | '/_app/employees/$employeeId'
    | '/_app/events/$eventId'
    | '/_app/projects/$projectId'
    | '/_app/companies/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  BookingTokenRoute: typeof BookingTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/stit': {
      id: '/_app/stit'
      path: '/stit'
      fullPath: '/stit'
      preLoaderRoute: typeof AppStitRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/booking/$token': {
      id: '/booking/$token'
      path: '/booking/$token'
      fullPath: '/booking/$token'
      preLoaderRoute: typeof BookingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/companies/': {
      id: '/_app/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AppCompaniesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies/$companyId': {
      id: '/_app/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/companies/$companyId'
      preLoaderRoute: typeof AppCompaniesCompanyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employees/$employeeId': {
      id: '/_app/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof AppEmployeesEmployeeIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events/$eventId': {
      id: '/_app/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AppEventsEventIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppCalendarRoute: typeof AppCalendarRoute
  AppInboxRoute: typeof AppInboxRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStitRoute: typeof AppStitRoute
  AppTeamRoute: typeof AppTeamRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCompaniesCompanyIdRoute: typeof AppCompaniesCompanyIdRoute
  AppEmployeesEmployeeIdRoute: typeof AppEmployeesEmployeeIdRoute
  AppEventsEventIdRoute: typeof AppEventsEventIdRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRoute
  AppCompaniesIndexRoute: typeof AppCompaniesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCalendarRoute: AppCalendarRoute,
  AppInboxRoute: AppInboxRoute,
  AppSearchRoute: AppSearchRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStitRoute: AppStitRoute,
  AppTeamRoute: AppTeamRoute,
  AppIndexRoute: AppIndexRoute,
  AppCompaniesCompanyIdRoute: AppCompaniesCompanyIdRoute,
  AppEmployeesEmployeeIdRoute: AppEmployeesEmployeeIdRoute,
  AppEventsEventIdRoute: AppEventsEventIdRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRoute,
  AppCompaniesIndexRoute: AppCompaniesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  BookingTokenRoute: BookingTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
